import {server} from '../Data/BuildEnvironment'
import {buildUrl} from '../Data/Http'
import {HttpRequest} from '../Data/HttpRequest'

export function listSuggestionsForCompany(
    companyId: number,
    search: string,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/companies/${companyId}/bps-users`,
                {limit: '12', search}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}

export function listSuggestionsForCustomer(
    customerId: number,
    search: string,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/customers/${customerId}/bps-users`,
                {limit: '12', search}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}

export function listSuggestions(search: string): HttpRequest {
    return {
        verb: 'GET',
        url: buildUrl(`${server}/bps-users`, {limit: '12', search}),
        headers: {
            'Accept': 'application/json',
        },
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/BpsUserResource.ts